import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import '@styles/index.css';
import '@styles/styles.css';
import '@styles/fonts.css';
import '@styles/scroll.css';

import AdminPage from "@pages/AdminPage";
import HomePage from "@pages/HomePage";
import PlayerPage from "@pages/PlayerPage";
import LoginPage from "@pages/LoginPage";
import CatalogPage from "@pages/CatalogPage";
import GenresPage from "@pages/GenresPage";
import ProfilePage from "@pages/ProfilePage";
import ProtectedAdmin from "@components/ProtectedAdmin";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/movies" element={<CatalogPage kind="movies" />} />
          <Route path="/series" element={<CatalogPage kind="series" />} />
          <Route path="/cartoons" element={<CatalogPage kind="cartoons" />} />
          <Route path="/anime" element={<CatalogPage kind="anime" />} />
          <Route path="/catalog" element={<CatalogPage kind="all" />} />
          <Route path="/genres" element={<GenresPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/admin" element={<ProtectedAdmin><AdminPage /></ProtectedAdmin>} />
          <Route path="/watch/:id" element={<PlayerPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "auto" }); }, [pathname, search]);
  return null;
}

export default App;
